import React, { useEffect, useState } from "react";
import { Card, CardBody, Media } from "reactstrap";
import gifImage from "../../../../public/images/Congrats.gif";
import { getBaseUrl, daysNameEvaluation, monthNames } from "../../../../actions/utility";
import ChaptersAccordion from "./ChaptersAccordion";
import yTubeIcon from "../../../../public/images/youtubeIcon.svg";
import worksheetIcon from "../../../../public/images/google-docs.png";
import customerIcon from "../../../../public/images/customer-support.png";
import moment from "moment";
import "moment-timezone";
import emptyUserImg2 from "../../../../public/images/empty.svg";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import AutoPlaySilentVideo from "./AutoPlaySilentVideo";
import $ from 'jquery';

const StudentMultipleUploadFeed = (props) => {
  const { item } = props;
  const { feed_data } = item;
  const [showChapters, setshowChapters] = useState(false);

  useEffect(() => {
    // Initialize the tooltip
    $('[data-toggle="tooltip"]').tooltip();
    
    // Apply custom style to tooltip
    $('[data-toggle="tooltip"]').on('shown.bs.tooltip', function () {
      const tooltipInner = document.querySelector('.tooltip-inner');
      if (tooltipInner) {
        tooltipInner.style.fontSize = '8px';
      }
    });

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      $('[data-toggle="tooltip"]').on('click', function () {
        const element = $(this);
        element.tooltip('show');
        
        setTimeout(() => {
          element.tooltip('hide');
        }, 2000); // Hide tooltip after 2 seconds
      });
    }

  }, []);

  const TDate = (scheduledTime) => {
    var ToDate = new Date();

    if (new Date(scheduledTime).getTime() <= ToDate.getTime()) {
      // alert("The Date must be Bigger or Equal to today date");
      return true;
    }
    return false;
  };
  const currentTimeZone = moment.tz.guess();

  console.log("Feed Data Multiple", JSON.parse(feed_data));
  return (
    <Card
      style={{
        marginBottom: "2vh",
        border: "1px #ccc solid",
        textAlign: "left",
      }}
      className="homeSection"
      id={item.user_feedid}
    >
      <CardBody>
        <div className="d-flex tutorImageSection">
          <div>
            <img
              className=""
              src={
                item.student_image
                  ? `https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.student_image}`
                  : emptyUserImg2
              }
              width="40"
              height="40"
            />
          </div>
          <div className="ml-2">
            <label>
              {item.student_name}
              <strong> uploads </strong>
            </label>{" "}
            <br />
            <span className="gradeName text-primary">{item.course_name}</span>
            <span style={{ fontSize: 10 }} data-toggle="tooltip" data-placement="bottom" title={item.created_at}>
              {moment.tz(item.created_at, "Asia/Karachi").tz(currentTimeZone).fromNow()}
            </span>
          </div>
        </div>
        <div className="mt-3">
        {JSON.parse(feed_data)?.[0]
                ?.message.split("/n")
                .map((part, index) => {
                  if (part.match(/^https?:\/\//i)) {
                    return (
                      <a
                        key={index}
                        href={part}
                        target="__blank"
                        className="mr-1"
                      >
                        {part}
                      </a>
                    );
                  } else {
                    return (
                      <span
                      style={{ whiteSpace: "pre-line", wordBreak: "break-word" }}
                      dangerouslySetInnerHTML={{ __html: part }}
                    ></span>
                    );
                  }
                })}
        </div>
        {
          JSON.parse(feed_data)[0]?.url
          && (
        <Carousel showThumbs={true} dynamicHeight={true} className="mt-3">
          {JSON.parse(feed_data)?.map((item, index) => (
            <div key={index}>
              {item?.url_type === "video" || item?.url_type === "file" ? (
                <AutoPlaySilentVideo video={item?.url} />
              ) : (
                <img src={item?.url} width="100%" />
              )}
            </div>
          ))}
        </Carousel>
          )
        }
      </CardBody>
    </Card>
  );
};

export default StudentMultipleUploadFeed;
